<div class="padding-b-70">
   <div class="contentBox">
      <ul class="brand-details-list team-list font-16 line-25">
         <li>
            <div class="">
               <div class="brand-head flex hr-space-between align-top margin-b-20">
                  <div class="">
                     <div class="icon brand-icon margin-b-15 wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="50ms">
                        <img src="assets/images/incedo.png" alt="">
                     </div>
                     <div class="font-15 light-color proximaNovaSb wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="100ms">Software Services
                     </div>
                  </div>
                  <div class="font-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="100ms">
                     <a href="https://www.incedoinc.com" class="highlight-color proximaNovaSb">www.incedoinc.com</a>
                  </div>
               </div>
               <div class="">
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Founded in 2011, Incedo is one of the fastest growing digital transformation and product
                     engineering firms.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Headquartered in US, Incedo has more than 4,000 technologists and business specialists dedicated to
                     helping clients achieve the best return on their investments. We help our clients achieve
                     competitive advantage through End-to-End Digital Transformation and work across Financial Services,
                     Telecom, Life Science & Healthcare and Product Engineering sectors. Our uniqueness lies in bringing
                     together strong engineering, data science and design capabilities with deep domain understanding,
                     and blurring the boundaries between services and products to maximize business impact from emerging
                     technologies. Further Incedo is developing market leading platforms that bring data analytics and
                     AI to help accelerate decision making.
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Incedo is focussed on helping Enterprises exploit the best of digital technologies to fundamentally
                     transform themselves and achieve competitive advantage. Incedo’s offerings are rooted in
                     The
                     <a href="https://www.incedoinc.com/about/incedo-belief-system/" target="_blank" class="highlight-color">
                     Incedo Belief System
                     </a>
                  </div>
                  <div class=" wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Mission Holdings is the majority shareholder in the company and Saurabh Mittal serves as its
                     Chairman.
                  </div>
               </div>
            </div>
         </li>
         <li id="nitin">
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/nitin.jpg" alt="">
               </div>
               <div class="margin-b-30 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Nitin Seth</div>
                  <div class="font-14 light-color proximaNovaSb">Co-founder & CEO</div>
               </div>
               <div class="social-media flex wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <a href="https://www.linkedin.com/in/nitinseth/" target="_blank" class="icon">
                     <img src="assets/images/linkedin.png" alt="">
                  </a>
                  <a href="https://twitter.com/seth_nitin?lang=en" target="_blank" class="icon margin-l-20">
                     <img src="assets/images/twitter.png" alt="">
                  </a>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              Nitin Seth is an accomplished industry leader with a unique combination of experiences – of an entrepreneur, a management consultant and a
              senior executive.
               </div>
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              As the Chief Executive Officer at Incedo, Nitin is responsible for definition and execution of Incedo’s strategy, creating and implementing on
              the company’s vision and mission and shaping a unique and effective organization culture. He is currently leading an organization wide
              transformation to realize the company’s goal of becoming a world-class technology solutions firm that delivers exceptional client value,
              has distinctive capabilities, and is an aspirational workplace for the best of minds.
               </div>
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              Nitin has led organizations and achieved significant impact by raising the trajectory of their businesses, driving from strategy to execution,
              championing innovation, building hi-performance teams, coaching and inspiring leaders and most importantly, leading with passion and integrity.
               </div>
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              Prior to Incedo, Nitin was the Chief Operating Officer of Flipkart, where he was responsible for customer and supply chain operations,
              strategy to execution capabilities and corporate functions for the company. He has also headed Fidelity International as the M.D and Country Head
               for India. Prior to Fidelity, Nitin was the Director of McKinsey’s Global Knowledge Centre in India (McKC).
                Nitin is a well-known and respected leader of the IT, BPO sector and Analytics industry. He has been elected twice to the NASSCOM Executive
                Council and was also the Chairperson of the Nasscom Regional Council (NRC) in Haryana.
              He is an avid speaker in the areas of entrepreneurship, business transformation and technology.
               </div>
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              He holds an MBA (Majors in Finance and Operations) from the Indian Institute of Management,
              Lucknow and a degree in engineering (B.Tech) from the Indian Institute of Technology, Delhi.
               </div>
               <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
              He is the author of two best-selling books: Winning in the Digital Age: Seven Building Blocks of a Successful Digital Transformation
              and Managing the Data Paradox: Key to Winning in the AI Age. He has twice served on the NASSCOM Executive Council and was Chairperson
               of the NASSCOM Regional Council (NRC) in Haryana, India.
               </div>




               <!-- <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
                  <div class="proximaNovaSb margin-b-10">Professional Experience:</div>
                  <ul class="points">
                     <li>Incedo, Inc: CEO (2017 - current)</li>
                     <li>Flipkart: Chief Operating Officer (2016-2017)</li>
                     <li>Fidelity: Head of Global Strategy and India Country Head (2010-2016)</li>
                     <li>NASSCOM: Chairperson, Haryana (2011 - 2016)</li>
                     <li>McKinsey Knowledge Center: Director (2002-2010)</li>
                     <li>ActiveKarma: Co-Founder (2000-2002)</li>
                     <li>McKinsey: Consultant (1996-2000)</li>
                  </ul>
               </div> -->
               <!-- <div class=" wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
                  <a routerLink="/capitals/platform-services" fragment="nitin" class="highlight-color sapientsansmedium font-14">More about Nitin Seth</a>
               </div> -->
            </div>
         </li>
         <!-- <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/krishna.jpg" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Krishna Rupanagunta</div>
                  <div class="font-14 light-color proximaNovaSb">President and Chief Customer Success Officer</div>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Krishna has 25+ years experience helping companies drive sustained business growth using Data and
                  Analytics. Over the years, he has built and led teams that have had an exceptional track record across
                  many roles in Services – Client Advisory, Product Management and Delivery in Decision Sciences and
                  Advanced Analytics. He is an acknowledged thought leader in the design and application of Big Data and
                  AI technologies in Customer Care Operations and Supply Chain Management across Retail, CPG and
                  High-Tech Industries.
               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  As the President and Chief Customer Success Officer at Incedo, Krishna is responsible for the design
                  and execution of programs that help Incedo’s customers realize transformative business value from
                  Digital Transformation and Data Science investments. He is passionate about helping companies bridge
                  the execution gap that is often created by the inability to bring together the Data Science and
                  Engineering capabilities to complement the problem-solving process.
               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Prior to Incedo, Krishna was the Head of Advanced Analytics and Data Science at Cisco, where he was
                  instrumental in building a global team that brought Data Science capabilities across Sales, Supply
                  Chain and Customer Service Operations. Prior to that, he was a member of the global leadership team at
                  Mu Sigma, one of the world’s largest pure-play Big Data and Analytics firms. He developed a deep
                  appreciation for the power of Big Data and Analytics during a stint in the non-profit sector in India
                  focused on bringing Technology to drive Social Change. He started out in Supply Chain and Operations
                  Consulting with E&Y/Capgemini serving multiple industries.
               </div>
               <div class="margin-b-15 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  He holds an MBA from Indian Institute of Management, Calcutta and a degree in Computer Science from
                  the Indian Institute of Technology, Delhi.
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  He blogs at <a href="http://www.thinklikesocrates.com" class="highlight-color">http://www.thinklikesocrates.com</a>
                  – most often his musings and lessons learnt from solving
                  some of the hardest problems for Fortune 500 companies using Data and Analytics.
               </div>
            </div>
         </li> -->
      </ul>
   </div>
</div>
